import { ref, computed } from 'vue';
import { createGlobalState } from '@vueuse/core';
import { useDisposes } from '@/composables/use-disposes';
import { injectService } from '@patsnap/tahiti-core/ioc/inject';
import { FreeViewLimitService } from '../service/free-view-limit.service';

export const useFreeViewLimit = createGlobalState(() => {
    const noPermissionService = injectService<FreeViewLimitService>(FreeViewLimitService);

    const { disposes } = useDisposes();

    const permissionTipState = ref(noPermissionService.state);

    disposes.push(noPermissionService.onStateChange(state => {
        permissionTipState.value = state;
    }));

    const isOverFreeViewLimit = computed(() => permissionTipState.value.isOverFreeViewLimit);
    const overFreeViewLimitMessage = computed(() => permissionTipState.value.limitMessage);

    function setIsOverFreeView(isOverFreeViewLimit: boolean, limitMessage?: string) {
        noPermissionService.updateState(isOverFreeViewLimit, limitMessage);
    }

    return {
        isOverFreeViewLimit,
        overFreeViewLimitMessage,
        setIsOverFreeView,
    };
});
